import axios from 'axios';

const HTTPUnintercepted = axios.create();

export default HTTPUnintercepted;
